import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import CheckboxDropdown from "@builder/components/general/CheckboxDropdown";
import Input from "@builder/components/general/Input";
import Toggle from "@builder/components/general/Toggle";
// import SelectInput from "@builder/components/general/SelectInput";
import { getCurrentLayer, getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { setActiveNode, updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { QueryFieldsProducts } from "@common/build/constants";
// import { QueryDataTables } from "@common/build/constants";
import { SearchFieldNode } from "@common/build/types";
import { useState } from "react";

const EditSearchField = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as SearchFieldNode;
    const [showLabel, setShowLabel] = useState(!!node.input?.label);
    const active = useAppSelector(state => state.builder.activeNode) === node.id;

    const targetID = node.filter?.target;
    const baseLayer = useAppSelector(getCurrentLayer);
    const target = targetID ? baseLayer.components[targetID] : null;
    const targetType = target?.query?.dataType;

    //Fields to search
    if (!target) return null;

    const searchOptionsProduct = [
        {
            value: QueryFieldsProducts.NAME,
            label: "Name",
            checked: node.filter?.fields?.includes(QueryFieldsProducts.NAME) || false
        },
        {
            value: QueryFieldsProducts.SKU,
            label: "SKU",
            checked: node.filter?.fields?.includes(QueryFieldsProducts.SKU) || false
        },
        {
            value: QueryFieldsProducts.BARCODE,
            label: "Barcode",
            checked: node.filter?.fields?.includes(QueryFieldsProducts.BARCODE) || false
        }
    ];

    const searchOptionsOrders = [
        {
            value: "orderNumber",
            label: "Order Number",
            checked: node.filter?.fields?.includes("orderNumber") || false
        },
        {
            value: "customerName",
            label: "Customer Name",
            checked: node.filter?.fields?.includes("customerName") || false
        },
        {
            value: "customerEmail",
            label: "Customer Email",
            checked: node.filter?.fields?.includes("customerEmail") || false
        },
        {
            value: "customerPhone",
            label: "Customer Phone",
            checked: node.filter?.fields?.includes("customerPhone") || false
        }
    ];

    const searchOptionsCustomers = [
        {
            value: "customerName",
            label: "Customer Name",
            checked: node.filter?.fields?.includes("customerName") || false
        },
        {
            value: "customerEmail",
            label: "Customer Email",
            checked: node.filter?.fields?.includes("customerEmail") || false
        },
        {
            value: "customerPhone",
            label: "Customer Phone",
            checked: node.filter?.fields?.includes("customerPhone") || false
        }
    ];

    const searchCallback = (option: { value: string; label: string; checked: boolean }) => {
        const filterValues = node.filter?.fields ? [...node.filter?.fields] : [];
        if (Array.isArray(filterValues)) {
            if (option.checked) {
                for (let i = 0; i < filterValues.length; i++) {
                    if (filterValues[i] === option.value) {
                        filterValues.splice(i, 1);
                    }
                }
            } else {
                filterValues.push(option.value);
            }
            dispatch(updateNodeProperty({ propertyPath: ["filter", "fields"], value: filterValues }));
        } else {
            dispatch(updateNodeProperty({ propertyPath: ["filter", "fields"], value: [option.value] }));
        }
    };

    //Label
    const label = node.input?.label || "";
    const labelCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["input", "label"], value }));
    };

    //Input placeholder
    const placeholder = node.input?.placeholder || "";
    const placeholderCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["input", "placeholder"], value }));
    };

    //Show Active
    const activeCallback = (checked: boolean) => {
        dispatch(setActiveNode(checked ? node.id : null));
    };

    return (
        <SidebarCollapse title="Search Field" parent={parent}>
            {/* <SelectInput title="Search type" layout="row" value={sT} options={searchTypeOptions} callback={searchTypeCallback} /> */}
            <CheckboxDropdown
                label="Fields to inlcude in Search"
                placeholder="Select fields"
                options={
                    targetType === "products"
                        ? searchOptionsProduct
                        : targetType === "orders"
                        ? searchOptionsOrders
                        : targetType === "customers"
                        ? searchOptionsCustomers
                        : []
                }
                getLabel={option => option.label}
                callback={searchCallback}
            />

            <Toggle
                label="Show label?"
                checked={showLabel}
                callback={() => {
                    labelCallback(showLabel ? "" : "Label");
                    setShowLabel(!showLabel);
                }}
            />
            {showLabel && <Input label="Label" placeholder="Enter label" value={label} callback={labelCallback} />}
            <Input label="Input placholder" placeholder="Enter placeholder" value={placeholder} callback={placeholderCallback} />
            <Toggle label="Set Active" checked={active} callback={activeCallback} />
        </SidebarCollapse>
    );
};

export default EditSearchField;
